// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

import { sentryEnvironment } from "./sentry-environment";
import { isKnownNonUserBrowserRejection } from "./lib/sentry/known-noise";

Sentry.init({
  dsn: "https://9af2563e60b2e0e2730638903fdce9a9@o4511311651667968.ingest.us.sentry.io/4511311652716544",
  environment: sentryEnvironment,
  enabled: sentryEnvironment === "production",

  // Session Replay: capture readable UI text and media (see privacy tradeoffs below).
  // https://docs.sentry.io/platforms/javascript/session-replay/privacy/#privacy-configuration
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false,
    }),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  beforeSend(event, hint) {
    if (
      isKnownNonUserBrowserRejection(hint.originalException) ||
      event.exception?.values?.some((exception) =>
        isKnownNonUserBrowserRejection(exception.value),
      )
    ) {
      return null;
    }

    return event;
  },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
